

const tickMargin = 10
const allowUpdate = true

// const usePerc = false

export const statCategories = {
  volleyball: {
    statCategory: {}, // StatCategory,
    matchData: null
  }
}

export const rts = {
  handleInit_thumbStat: 'handleInit_thumbStat',
  handleSidebarOpen: 'handleSidebarOpen',
  handleChange: 'handleSidebarOpen',
  handleLineup: 'handleLineup',
  handleChangeExact: 'handleChangeExact',
  updateSwipeAction: 'updateSwipeAction',
  handleAllowSwipeChange: 'handleAllowSwipeChange',
  resetView: 'resetView',
}

export const thumbStatReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleInit_thumbStat:
      return { ...state, ...action.initState }

    default:
      return { ...state }
  }
}

export const thumbStatInitialState = (initState, sportName) => {
  const statCategory = statCategories[sportName]?.statCategory
  const init = {
    groupType: statCategory?.groupTypes?.startPoint,
    statGroup: statCategory?.statGroups?.[statCategory?.groupTypes?.startPoint],
    statView: statCategory?.statGroups?.[statCategory?.groupTypes?.startPoint],
    matchScoreStatus: statCategory?.matchScoreStatus,
    requestViewType: null,
    statGroupStatItem: null,
    directRequest: null,
    selectedRosterTeam: null,
    fullPage: false,
    showScore: true,
    allowSwipe: true,
    allowSwipeHold: false,
    showItemStats: true,
    sidebarLeftOpen: false,
    sidebarRightOpen: false,
    swipeProps: null,
  }
  return { ...initState, ...init }
};

export const thumbStatHandlers = (dispatch, state) => {
  return {
    handleInit_thumbStat: (initState) => { dispatch({ type: rts.handleInit_thumbStat, initState }) },
  }
}
